import React from 'react';
import styled from 'styled-components';
import {device} from 'styled/device';
import {map} from 'lodash';
import {useTranslation} from 'react-i18next';
import Select from '../../components/Select';
import {SelectOptionType} from '../../utils/types';

const Container = styled.div`
  display: flex;
  padding: 50px 0;
  width: 100%;

  .mobileCategories {
    display: none;
    width: 100%;
    @media (max-width: ${device.tablet}) {
      display: block;
    }
  }

  @media (max-width: ${device.tablet}) {
    padding: 0 0 40px 0;
    margin: 0 auto;
    max-width: 60%;
  }

  @media (max-width: ${device.mobileXL}) {
    max-width: none;
  }
`;

const CategoriesSelect = styled(Select)`
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  flex-wrap: wrap;

  .navlink {
    cursor: pointer;
    padding: 5px 30px;
    color: #6b6b95;
    font-size: 15px;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    text-transform: capitalize;
    white-space: nowrap;
  }
  .navlink:hover,
  .active {
    background-color: #353945;
    border-radius: 25px;
    padding: 5px 30px;
    color: #ffffff;
    font-size: 15px;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
  }

  @media (max-width: ${device.tablet}) {
    display: none;
  }
`;

type Props = {
  categories?: any;
  setSelectedCategory?: any;
  selectedCategory?: string;
};

function ExperiencesNavigation({
  categories,
  setSelectedCategory,
  selectedCategory,
}: Props) {
  const {t} = useTranslation();
  const handleClick = (category: string) => {
    setSelectedCategory(category);
  };

  const handleChange = (category: string) => {
    setSelectedCategory(category);
  };

  const categoriesOptionMobile = React.useMemo(() => {
    const options = categories.map((category: string) => {
      const categoriesName = category.toLowerCase();

      return {
        value: category,
        label: t(categoriesName),
      };
    });
    const defaultOption = {value: '', label: t('all')};
    return [defaultOption, ...options];
  }, [categories, t]);
  const selectedCategoryOption = categoriesOptionMobile.find(
    option => option.value === selectedCategory,
  );

  return (
    <Container>
      <Row>
        <div
          className={selectedCategory !== '' ? 'navlink' : 'navlink active'}
          onClick={() => handleClick('')}
        >
          {t('all')}
        </div>
        {map(categories, (category: string, index: number) => {
          const categoryName = category.toLowerCase();

          return (
            <div
              className={
                category === `${selectedCategory}` ? 'navlink active' : 'navlink'
              }
              onClick={() => handleClick(category)}
              key={index}
            >
              {t(categoryName)}
            </div>
          );
        })}
      </Row>
      <div className="mobileCategories">
        <CategoriesSelect
          options={categoriesOptionMobile}
          value={selectedCategoryOption}
          onChange={(event: SelectOptionType) => handleChange(event.value as string)}
        />
      </div>
    </Container>
  );
}

export default ExperiencesNavigation;
